import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_CTC } from '$Deposits/store/actions/DepositPost'
import { CHANNEL_Submit, CTC_Submit } from '$Deposits/store/actions/DepositEvent'
import { GetParamsData } from '$Deposits/lib/LibCommonData'



class CTC extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
        };
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    componentDidUpdate(prevProps, prevState){
        const { webPiwikUrl } = GetParamsData()
        const {modalVisible} = this.state;
        const {DepositBankActive, DepositNextStep, MethodCodeActive} = this.props;
        if(prevState.modalVisible!==modalVisible){
            if(modalVisible){
                if(MethodCodeActive==="CHANNEL"){
                    webPiwikUrl(`deposit_${DepositBankActive.code}_popup`,`CTC ${DepositBankActive.code} Popup`)
                }else if(MethodCodeActive==="INVOICE"){
                    webPiwikUrl(`deposit_invoice_popup`,`CTC Deposit Invoice Flow Popup`)
                }
            }else{
                if(!DepositNextStep){
                    webPiwikUrl(`deposit_ctc`,`CTC Deposit Page`)
                }
            }
        }
    }

    render() {

        const {
            SetDepositPayments_CTC,
            DepositNextStep,
            DepositSuccessPage,
            MethodCodeActive,
            TipsView,
            AvailableMethods,
            MoneyInput,
            BankSelect,
            SubmitBtn,
            NextStep,
            CHANNEL_NextStep,
            SuccessPage,
            Modal,
            DepositBankActive,
        } = this.props
        const { code } = DepositBankActive || {}

        return (
            <>
                <Modal
                    modalVisible={this.state.modalVisible}
                    code={code}
                    onChange={() => {
                        this.setState({ modalVisible: false }, () => {
                            SetDepositPayments_CTC()
                        })
                    }}
                    onCancel={() => { this.setState({ modalVisible: false }) }}
                />
                {
                    (!DepositNextStep || MethodCodeActive != 'CHANNEL') && !DepositSuccessPage &&
                    <>
                        <TipsView msg={`Lưu ý quan trọng: Nếu bạn sử dụng tiền mã hóa để thanh toán, một số nền tảng sẽ phát sinh phí xử lý.`} />
                        <AvailableMethods />
                        <MoneyInput />
                        <BankSelect />
                        <SubmitBtn
                            submitBtn={CTC_Submit}
                            onPress={() => {
                                this.setState({ modalVisible: MethodCodeActive == 'CHANNEL' })
                                if(MethodCodeActive == 'INVOICE') SetDepositPayments_CTC()
                                const { appPiwikEvent, device } = GetParamsData()
                                if (device === 'APP') {
                                    if (MethodCodeActive == 'CHANNEL') {
                                        appPiwikEvent({
                                            path: `deposit_${code}_popup`,
                                            title: `Crypto ${code} Popup`
                                        })
                                    } else {
                                        appPiwikEvent({
                                            path: `deposit_invoice_popup`,
                                            title: `Crypto Deposit Invoice Flow Popup`
                                        })
                                    }
                                   
                                }
                            }}
                            submitBtnItem={'Tiếp Theo'}
                        />
                    </>
                }
                {
                    MethodCodeActive != 'CHANNEL' && DepositNextStep &&
                    <NextStep />
                }
                {
                    MethodCodeActive == 'CHANNEL' && DepositNextStep &&
                    <CHANNEL_NextStep />
                }

                {
                    DepositSuccessPage &&
                    <SuccessPage />
                }

            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodCodeActive: state.MethodCodeActive,
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    DepositBankActive: state.DepositBankActive,
});
const mapDispatchToProps = {
    SetDepositPayments_CTC: (data = {}) => SetDepositPayments_CTC(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(CTC);


